module.exports = __webpack_public_path__ + "media/images/gallery/constellations/aries/ari_lines-73c63211608c306bc81becf9d4c51abd.gif";